export class Role {
    RoleId: string = '';
    RoleName: string = '';
    CreatedDate: Date;
    RoleActive: boolean = true;
    CreatedBy:string;
    ModifiedBy:string;
    ModifiedDate:Date;
}